// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './quotes.scss';

// Redux
import { connect } from 'react-redux';
import FinancialService from '../../../redux/services/finance';
import { getQuoteList } from '../../../redux/actions/quote';

// Utils
import { PAYMENT_CHANNEL_CREDIT_CARD, PAYMENT_CHANNEL_DIRECT_DEBIT, PAYMENT_CHANNEL_MB, PAYMENT_CHANNEL_MBWAY, PAYMENT_STATE_PAYED, QUOTE_STATE_FINANCE_PROCESS, QUOTE_STATE_FREE, QUOTE_STATE_PAYED, QUOTE_STATE_WAITING_PAYMENT } from '../../../common/constants';
import { PAYMENT_CHANNEL_BANK_TRANSFER } from '../../../common/constants';
import _ from 'lodash';

class QuotePaymentListComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
    }

    componentDidMount() {
        this.props.getQuoteList(this.props.associate.associateId);
    }

    downloadInvoice(invoiceRef) {
        FinancialService.generateInvoicePdf(invoiceRef)
        .then((response) => {
            window.open(response.output.pdfUrl, '_blank');
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    amountBodyTemplate(rowData) {
        if(rowData.amount === null) {
            return "";
        }
        else {
            if(rowData.amount.toString().includes(".")) {
                let amountParts = rowData.amount.toString().split(".");

                if(amountParts[1].length === 1) {
                    return rowData.amount + "0 €";
                }
                else {
                    return rowData.amount + " €";
                }     
            }
            else {
                return rowData.amount + ".00 €";
            }
        }
    }

    priceBodyTemplate(rowData) {
        if(rowData.price === null) {
            return "";
        }
        else {
            if(rowData.price.toString().includes(".")) {
                let priceParts = rowData.price.toString().split(".");

                if(priceParts[1].length === 1) {
                    return rowData.price + "0 €";
                }
                else {
                    return rowData.price + " €";
                }     
            }
            else {
                return rowData.price + ".00 €";
            }
        }
    }

    monthBodyTemplate(rowData) {
        switch(rowData.month) {
        case 1: return this.props.t("general.months.jan"); break;
        case 2: return this.props.t("general.months.fev"); break;
        case 3: return this.props.t("general.months.mar"); break;
        case 4: return this.props.t("general.months.abr"); break;
        case 5: return this.props.t("general.months.mai"); break;
        case 6: return this.props.t("general.months.jun"); break;
        case 7: return this.props.t("general.months.jul"); break;
        case 8: return this.props.t("general.months.ago"); break;
        case 9: return this.props.t("general.months.set"); break;
        case 10: return this.props.t("general.months.out"); break;
        case 11: return this.props.t("general.months.nov"); break;
        case 12: return this.props.t("general.months.dez"); break;
        }
    }

    dateBodyTemplate(rowData, column) {
    if(rowData[column] !== null) {
        return rowData[column] !== undefined ? rowData[column].replace('T',' ') : "";
    }
    else {
        return "";
    }
    }

    stateBodyTemplate(rowData) {
        if(rowData.state === QUOTE_STATE_PAYED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("quotes.form.payed")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("quotes.form.waiting-payment")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_FREE) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#000000'}}>{this.props.t("quotes.form.free")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_FINANCE_PROCESS) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("quotes.form.finance-process")}</span>;
        }
        else {
        return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("quotes.form.missing")}</span>;
        }
    }

    paymentChannelBodyTemplate(rowData) {
        if(rowData.paymentChannel === PAYMENT_CHANNEL_MB) {
            return this.props.t("quotes.form.payment-channel-mb");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_MBWAY) {
            return this.props.t("quotes.form.payment-channel-mbway");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_CREDIT_CARD) {
            return this.props.t("quotes.form.payment-channel-credit-card");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_BANK_TRANSFER) {
            return this.props.t("quotes.form.payment-channel-bank-transfer");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_DIRECT_DEBIT) {
            return this.props.t("quotes.form.payment-channel-direct-debit");
        }
        else {
            return null;
        }
    }

    invoiceDownloadBodyTemplate(rowData) {
        return rowData.state === QUOTE_STATE_PAYED ? <Button icon="pi pi-download" onClick={() => this.downloadInvoice(rowData.invoiceRef)} /> : null;
    }

    transformQuotesDataSource(serverQuotes) {
        let transformedQuotes = [];
        let quotesGroupedByInvoice = _(serverQuotes).groupBy(x => x.invoiceRef).map((value, key) => ({invoiceRef: key, quotes: value})).value();

        for (let i = quotesGroupedByInvoice.length - 1; i >= 0; i--) {

            if(quotesGroupedByInvoice[i].invoiceRef !== "null") {
                let month = <div>
                {
                    quotesGroupedByInvoice[i].quotes.map((quote) => { 
                        return <p>{this.monthBodyTemplate(quote)}</p>;
                    })
                }
                </div>

                transformedQuotes.push({
                    year: quotesGroupedByInvoice[i].quotes[0].year,
                    month: month,
                    state: quotesGroupedByInvoice[i].quotes[0].state,
                    paymentDate: quotesGroupedByInvoice[i].quotes[0].paymentDate,
                    paymentChannel: quotesGroupedByInvoice[i].quotes[0].paymentChannel,
                    amount: quotesGroupedByInvoice[i].quotes[0].amount,
                    invoiceRef: quotesGroupedByInvoice[i].invoiceRef
                });
            }
        }
        
        return transformedQuotes;
    }

    render() {

       return (
            <div>
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className="col-12">                   
                        <div id="data-container" className="card mgt-20">
                        {
                            this.props.quotes !== null ? 
                                <div className="grid">
                                    <div className="col-12">
                                        <DataTable value={this.transformQuotesDataSource(this.props.quotes)} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("quotes.messages.no-quotes")}>
                                            <Column field="year" header={this.props.t("quotes.form.year-header")} style={{ minWidth: '50px' }}  />
                                            <Column field="month" header={this.props.t("quotes.form.month-header")}   />
                                            <Column field="state" header={this.props.t("quotes.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                            <Column field="paymentDate" header={this.props.t("quotes.form.payment-date-header")} body={(data) => this.dateBodyTemplate(data, 'paymentDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="amount" header={this.props.t("quotes.form.amount-header")} body={(data) => this.amountBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                            <Column field="paymentChannel" header={this.props.t("quotes.form.channel-header")} body={(data) => this.paymentChannelBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                            <Column field="invoiceRef" header={this.props.t("quotes.form.invoice-header")} body={(data) => this.invoiceDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        </DataTable>
                                    </div>
                                </div>
                                : null
                        }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        quotes: state.quote.quotes
    } 
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        getQuoteList: (associateId) => { dispatch(getQuoteList(associateId)) }
    }
  };

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(QuotePaymentListComponent));